import * as React from "react";
import {defineMessages, InjectedIntlProps, injectIntl} from "react-intl";
import {connect} from "react-redux";
import {createAddButtonComponent} from "../common/ui/AddButton";
import {actions} from "./actions";
import {Style} from "./model";
import {NewFileInfo} from "../data/model";
import {WithApi} from "../common/util/WithApi";

const AddButtonComponent = WithApi(createAddButtonComponent<Style>());

const mapDispatchToProps = (dispatch, _ownProps) => ({
  onAdd: (file: NewFileInfo) => {
    return dispatch(actions.addStyle({filePath: file.filePath}));
  },
});

interface AddStyleButtonDispatchProps {
  onAdd: (file: NewFileInfo) => Promise<Style>;
}

interface AddStyleButtonProps {
  onAddSuccess: () => void;
}

const STYLE_MESSAGES = defineMessages({
  buttonTitle: {
    id: "studio.styles.add-style-button.button-title",
    defaultMessage: "Add SLD Style",
  },
  chooseFile: {
    id: "studio.styles.add-style-button.choose-file",
    defaultMessage: "Choose File",
  },
  selectStyle: {
    id: "studio.styles.add-style-button.select-data",
    defaultMessage: "Select Style",
  },
  helperText: {
    id: "studio.styles.add-style-button.helper-text",
    defaultMessage: "Enter the location of the style you want to add, e.g Data/SLD/world.xml",
  },
  executingMessage: {
    id: "studio.styles.add-style-button.executing-message",
    defaultMessage: "Adding style...",
  },
});

class AddStyleButtonComponent extends React.Component<AddStyleButtonProps & InjectedIntlProps & AddStyleButtonDispatchProps, any> {
  render() {
    const {intl, onAdd, onAddSuccess} = this.props;
    return <AddButtonComponent
        buttonTitle={intl.formatMessage(STYLE_MESSAGES.buttonTitle)}
        confirmButtonTitle={intl.formatMessage(STYLE_MESSAGES.buttonTitle)}
        modalTitle={intl.formatMessage(STYLE_MESSAGES.buttonTitle)}
        chooseFileTitle={intl.formatMessage(STYLE_MESSAGES.selectStyle)}
        chooseFileButtonTitle={intl.formatMessage(STYLE_MESSAGES.chooseFile)}
        addHelperText={intl.formatMessage(STYLE_MESSAGES.helperText)}
        executingMessage={intl.formatMessage(STYLE_MESSAGES.executingMessage)}
        onAdd={onAdd}
        onAddSuccess={onAddSuccess}
        intl={intl}/>;
  }
}

export const AddStyleButton = injectIntl(connect(null, mapDispatchToProps)(AddStyleButtonComponent));